export { default } from './SeguroAuto25Condicoes';
